import { documentationSlugFromFileName } from "shared/documentation";

export type DocumentationFileMetadata = {
  readonly title: string;
  readonly code: string | null;
  readonly slug: string;
};

/** The element the reference documents print their code in, e.g. `ADM-CFG-5`. */
const CODE_SELECTOR = ".wi-id";

/**
 * Suggested title, code and slug for an uploaded document, so the author only
 * has to confirm them. The title comes from `<title>` (else the first `<h1>`,
 * else the file name), the code from the `.wi-id` badge the documents carry,
 * and the slug from the file name, which is how other documents link to it.
 */
export const readDocumentationFileMetadata = (
  fileName: string,
  html: string,
): DocumentationFileMetadata => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const slug = documentationSlugFromFileName(fileName);
  const title =
    textOf(doc.querySelector("title")) ??
    textOf(doc.querySelector("h1")) ??
    slug;
  return { title, code: textOf(doc.querySelector(CODE_SELECTOR)), slug };
};

const textOf = (element: Element | null): string | null => {
  const text = element?.textContent?.replaceAll(/\s+/g, " ").trim() ?? "";
  return text === "" ? null : text;
};
